import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { FILTER_PRICE } from 'dpl/constants/query_params';
import { LEARNING_CENTER_PRICE_PATH } from 'dpl/shared/constants/urls';
import { beginsWithVowel } from 'dpl/shared/utils';
import SmartLink from 'dpl/components/SmartLink';

import MultiSelectChecklistFilter from './MultiSelectChecklistFilter';

export default function PriceFilter({ title }) {
  const { puppyPriceRanges, breedName, medianBreedPrice } = useSelector(
    ({ server }) => server
  );

  return (
    <>
      {title && (
        <p className="mb4 font-16 fw-medium md:font-18 md:font-serif">
          {title}
        </p>
      )}
      {/*
          Calculating average price can be inaccurate due to pricing outliers. Using a
          calculated median price based off breed's litter price range low/high values instead.
        */}
      {Boolean(medianBreedPrice) && (
        <p className="f2 mb4 lh-copy">
          The average price of {beginsWithVowel(breedName) ? 'an' : 'a'}{' '}
          {breedName} puppy is {medianBreedPrice}.{' '}
          <SmartLink
            className="underline"
            to={LEARNING_CENTER_PRICE_PATH}
            target="_blank"
          >
            Learn more
          </SmartLink>
        </p>
      )}
      <MultiSelectChecklistFilter
        filterParam={FILTER_PRICE}
        filterOptions={puppyPriceRanges}
      />
    </>
  );
}

PriceFilter.propTypes = {
  title: PropTypes.string
};

PriceFilter.defaultProps = {
  title: null
};
